import { Box } from '@mui/material';
import type { AvailableExtensionDocument } from 'lib/api/extension/factoring';
import { MultiAutocompleteInput } from 'lib/common/Inputs';
import PageHeader from 'lib/designSystem/PageHeader';
import React, { useMemo } from 'react';

export interface StepSelectDocumentsProps {
  suggestions: AvailableExtensionDocument[];
  loading?: boolean;
  selectedDocuments: AvailableExtensionDocument[];
  onSelectedDocumentsChange: (docs: AvailableExtensionDocument[]) => void;
}

const StepSelectDocuments: React.FC<StepSelectDocumentsProps> = ({
  suggestions,
  loading,
  selectedDocuments,
  onSelectedDocumentsChange,
}) => {
  const helperText = useMemo(() => {
    if (loading) return '';
    if (suggestions.length === 0) return 'No hay documentos disponibles.';
    return `Seleccionados: ${selectedDocuments.length}`;
  }, [loading, suggestions.length, selectedDocuments.length]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <PageHeader variant="dialogHeader">
        <PageHeader.Main>
          <PageHeader.TitleSection
            iconType="documents"
            title="Seleccionar documentos para prórroga"
            subtitle="Puedes seleccionar múltiples documentos."
          />
        </PageHeader.Main>
      </PageHeader>

      <MultiAutocompleteInput<AvailableExtensionDocument>
        label="Buscar documentos por folio, cliente o deudor"
        placeholder="Selecciona documentos..."
        value={selectedDocuments}
        onChange={onSelectedDocumentsChange}
        options={suggestions}
        loading={loading}
        noOptionsText="Sin resultados"
        getOptionLabel={(option) =>
          `${option.folio} | ${option.businessName} | ${option.stakeholderName}`
        }
        isOptionEqualToValue={(option, value) => option.id === value.id}
        helperText={helperText}
        loadingText="Buscando documentos..."
      />
    </Box>
  );
};

export default StepSelectDocuments;
